import SEAT_CHOICE_TYPES from '../../scripts/constants/seat-choice-types';
import regexMap from '../../scripts/constants/regex-map';
import SeatChoiceUIModel from './seat-choice';
import SeatChoiceUpsellUIModel from './seat-choice-upsell';
import SeatChoiceFareUpgradeUIModel from './seat-choice-fare-upgrade';
import SeatChoiceDeltaUIModel from './seat-choice-delta';

class SeatUIModel {
  /**
   * constructor
   * @param {Object} options
   */
  constructor({
    choice = null,
    code = '',
    status = '',
    noInfant = '',
  }) {
    this.code = code;
    this.status = status;
    this.noInfant = noInfant;

    if (choice) {
      const seatChoiceClass = choice._meta.class;
      this.seatChoiceClass = seatChoiceClass;
      switch (seatChoiceClass) {
        case SEAT_CHOICE_TYPES.SEAT_CHOICE:
          this.choice = new SeatChoiceUIModel(choice);
          break;
        case SEAT_CHOICE_TYPES.SEAT_CHOICE_UPSELL:
          this.choice = new SeatChoiceUpsellUIModel(choice);
          break;
        case SEAT_CHOICE_TYPES.SEAT_CHOICE_DELTA:
          this.choice = new SeatChoiceDeltaUIModel(choice);
          break;
        case SEAT_CHOICE_TYPES.SEAT_CHOICE_FARE_UPGRADE:
          this.choice = new SeatChoiceFareUpgradeUIModel(choice);
          break;
      }

      if (this.choice && this.choice.isExitRowSeat) {
        return 'EXIT_ROW';
      }
    }
  }

  getSeatLabel() {
    if (!this.choice) return;

    return this.choice.getSeatLabel();
  }

  getSeatLetter() {
    return this.code.replace(regexMap.NON_ALPHA_CHARS, '');
  }

  getSeatTypeCopyID() {
    if (this.choice.isWindowSeat) {
      return 'SEATMAP_SEAT_TYPE_WINDOW';
    } else if (this.choice.isAisleSeat) {
      return 'SEATMAP_SEAT_TYPE_AISLE';
    } else if (this.choice.isMiddleSeat) {
      return 'SEATMAP_SEAT_TYPE_MIDDLE';
    } else if (this.choice.isExitRowSeat) {
      return 'EXIT_ROW';
    }
  }
}

export default SeatUIModel;
